import styled from 'styled-components';

const EmptyState = styled.div`
    padding: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.textMuted || '#6b7280'};
    font-size: 0.875rem;
    background: ${({ theme }) => theme.colors.surfaceAlt || '#f9fafb'};
    border: 1px dashed ${({ theme }) => theme.colors.border || '#e5e7eb'};
    border-radius: 12px;
`;

export default EmptyState;
